const MAX_DIFF_CHARS = 3000

function splitChars(str) {
  return Array.from(str || '')
}

/**
 * 字符级 diff，返回 [{ type: 'equal'|'delete'|'insert', text }]
 */
export function diffText(original, modified) {
  const aStr = original || ''
  const bStr = modified || ''

  if (aStr === bStr) {
    return aStr ? [{ type: 'equal', text: aStr }] : []
  }
  if (!aStr) {
    return [{ type: 'insert', text: bStr }]
  }
  if (!bStr) {
    return [{ type: 'delete', text: aStr }]
  }

  const a = splitChars(aStr.length > MAX_DIFF_CHARS ? aStr.slice(0, MAX_DIFF_CHARS) : aStr)
  const b = splitChars(bStr.length > MAX_DIFF_CHARS ? bStr.slice(0, MAX_DIFF_CHARS) : bStr)
  const n = a.length
  const m = b.length

  const dp = new Array(n + 1)
  for (let i = 0; i <= n; i++) {
    dp[i] = new Array(m + 1).fill(0)
  }

  for (let i = 1; i <= n; i++) {
    for (let j = 1; j <= m; j++) {
      if (a[i - 1] === b[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1] + 1
      } else {
        dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1])
      }
    }
  }

  const raw = []
  let i = n
  let j = m
  while (i > 0 || j > 0) {
    if (i > 0 && j > 0 && a[i - 1] === b[j - 1]) {
      raw.unshift({ type: 'equal', char: a[i - 1] })
      i -= 1
      j -= 1
    } else if (j > 0 && (i === 0 || dp[i][j - 1] >= dp[i - 1][j])) {
      raw.unshift({ type: 'insert', char: b[j - 1] })
      j -= 1
    } else {
      raw.unshift({ type: 'delete', char: a[i - 1] })
      i -= 1
    }
  }

  const merged = []
  raw.forEach(item => {
    const last = merged[merged.length - 1]
    if (last && last.type === item.type) {
      last.text += item.char
    } else {
      merged.push({ type: item.type, text: item.char })
    }
  })

  return merged
}
